/* =========================================================================
   Penny Premium 3D — slider.js
   Shared helper for CSS scroll-snap rows (Penny Picks, testimonials, and
   any future carousel). The track scrolls natively; JS only powers the
   arrow buttons, the progress bar, and their enabled/hidden states.

   Markup contract:
     [data-slider]
       [data-slider-track]        — the scroll-snap container
       [data-slider-prev] / [data-slider-next]
       [data-slider-progress]     — optional; thin bar, scaleX driven
   When the track isn't scrollable the root gets data-slider-static="true"
   (CSS hides the controls).
   ========================================================================= */

const motionFull = () => document.documentElement.classList.contains('motion-full');
const initialized = new WeakSet();

function initSlider(rootEl) {
  const track = rootEl.querySelector('[data-slider-track]');
  if (!track || initialized.has(rootEl)) return;
  initialized.add(rootEl);

  const prev = rootEl.querySelector('[data-slider-prev]');
  const next = rootEl.querySelector('[data-slider-next]');
  const progress = rootEl.querySelector('[data-slider-progress]');
  let ticking = false;

  const update = () => {
    ticking = false;
    const maxScroll = track.scrollWidth - track.clientWidth;
    rootEl.dataset.sliderStatic = String(maxScroll <= 1);
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
    if (progress) {
      const visible = (track.scrollLeft + track.clientWidth) / track.scrollWidth;
      progress.style.transform = `scaleX(${Math.min(visible, 1)})`;
    }
  };

  const scrollByStep = (direction) => {
    // One "step" = the first item's width incl. gap, so cards land on snaps
    const item = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    track.scrollBy({ left: step * direction, behavior: motionFull() ? 'smooth' : 'auto' });
  };

  prev?.addEventListener('click', () => scrollByStep(-1));
  next?.addEventListener('click', () => scrollByStep(1));
  track.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );
  new ResizeObserver(update).observe(track);
  update();
}

function initAll() {
  document.querySelectorAll('[data-slider]').forEach(initSlider);
}

initAll();
document.addEventListener('shopify:section:load', initAll);
